import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { HandCoins, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PaymentNudge = ({ booking, token, onSaved }) => {
  const [sending, setSending] = useState(false);
  const balance = Math.max(0, (Number(booking.total_price) || 0) - (Number(booking.discount) || 0) - (Number(booking.amount_paid) || 0));
  if (balance <= 0 || booking.status === "cancelled") return null;

  const send = async (force = false) => {
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/bookings/${booking.id}/payment-nudge`, { force },
        { headers: { Authorization: `Bearer ${token}` } });
      if (data.already_sent_today) {
        if (window.confirm("A payment reminder was already sent to this customer today. Send another one anyway?")) {
          await send(true);
        }
        return;
      }
      toast.success(`Payment reminder sent by ${data.channels.join(" + ")} — $${data.balance.toFixed(2)} balance.`);
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send the payment reminder.");
    } finally {
      setSending(false);
    }
  };

  return (
    <button data-testid={`payment-nudge-${booking.id}`} onClick={() => send(false)} disabled={sending}
      className="text-xs flex items-center gap-1.5 border border-emerald-500/50 text-emerald-300 px-3 py-1.5 rounded hover:bg-emerald-500 hover:text-black transition-colors disabled:opacity-50">
      {sending ? <Loader2 className="animate-spin" size={13} /> : <HandCoins size={13} />}
      Send Payment Reminder (${balance.toFixed(0)})
    </button>
  );
};

export default PaymentNudge;
